import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imSearchableSelect', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/searchable-select/searchable-select.html'),
        controller: 'ImSearchableSelectController',
        controllerAs: 'ImSearchableSelectCtrl',
        bindings: {
            apiFunction: '<',
            apiDisplay: '<',
            placeholderText: '<',
            inputName: '<',
            alternativeSearchName: '<',
            selectedObject: '=',
            clearOnSelect: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/searchable-select/searchable-select.component.ts